// tslint:disable:max-line-length

import React from 'react';

export const ChartArea = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon opacity=".3" points="11.5,12.5 8.5,9.5 5,13 0,13 0,16 16,16 16,9" />
      <polygon points="16,0 11.5,5 8.5,3 3.5,8.5 0,8.5 0,11.5 4.5,11.5 8.5,7.5 11.5,10.5 16,7" />
    </svg>
  );
};
